import type { AssetBalanceDto } from '@shared/api/contracts';
import { clampNonNegative } from '@shared/lib/format-amount';
import { normalizeAssetBalances } from '@shared/lib/asset-balance';

export const normalizeWithdrawalNetworkCode = (network: string): string =>
  network.trim().toUpperCase().replace(/-/g, '');

/** Spendable USDT on a network. Null means the available figure is unknown — never the booked total. */
export const getUsdtBalanceByNetwork = (
  assetBalances: AssetBalanceDto[] | unknown,
  network: string,
): number | null => {
  if (!network.trim() || !Array.isArray(assetBalances)) {
    return null;
  }

  const normalizedNetwork = normalizeWithdrawalNetworkCode(network);
  const rows = normalizeAssetBalances(assetBalances);
  const match = rows.find(
    (balance) =>
      balance.assetCode === 'USDT' &&
      normalizeWithdrawalNetworkCode(balance.network) === normalizedNetwork,
  );

  if (!match) {
    return 0;
  }

  if (match.availableAmount == null || match.availableAmount === '') {
    return null;
  }

  const amount = Number.parseFloat(match.availableAmount);
  if (Number.isNaN(amount)) {
    return null;
  }

  return clampNonNegative(amount);
};
